// extracted by mini-css-extract-plugin
module.exports = {"inner":"Destinations_inner__1_oxA","head":"Destinations_head__2SPyo","wrapper":"Destinations_wrapper__46RTH","button":"Destinations_button__4tlgl"};